<div class="content">
<div class="categories">
  <div class="category">
    <h3>Product</h3>
    <ul>
      <li><a routerLink="/features">Features</a></li>
      <li><a routerLink="/pricing">Pricing</a></li>
    </ul>
  </div>

  <div class="category">
    <h3>Resources</h3>
    <ul>
      <li><a routerLink="/guide">Guide</a></li>
      <li><a routerLink="/enterprise">Dash Enterprise</a></li>
      <li><a routerLink="/contact">Contact us</a></li>
    </ul>
  </div>

  <div class="category">
    <h3>Download</h3>
    <ul>
      <li><a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382">App Store</a></li>
      <li><a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware">Play Store</a></li>
      <li><a href="https://www.amazon.com/gp/product/B0D4DY15WY">Amazon Store</a></li>
    </ul>
  </div>
</div>
<div class="company">
	<div class="logo"></div>
	<a class="legal" routerLink="/terms-of-service">Terms of Service</a>
  <a class="legal" routerLink="/privacy-policy">Privacy policy</a>
  <div class="copyright"><a href="https://www.aptsoftware.co.nz">&copy; 2019-25 Apt Software Ltd.</a></div>
</div>
</div>
